var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3408_10246",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3408_10246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00059 10.0496L5.32559 13.7246C5.18809 13.8621 5.01309 13.9309 4.80059 13.9309C4.58809 13.9309 4.41309 13.8621 4.27559 13.7246C4.13809 13.5871 4.06934 13.4121 4.06934 13.1996C4.06934 12.9871 4.13809 12.8121 4.27559 12.6746L7.95059 8.99961L4.27559 5.32461C4.13809 5.18711 4.06934 5.01211 4.06934 4.79961C4.06934 4.58711 4.13809 4.41211 4.27559 4.27461C4.41309 4.13711 4.58809 4.06836 4.80059 4.06836C5.01309 4.06836 5.18809 4.13711 5.32559 4.27461L9.00059 7.94961L12.6756 4.27461C12.8131 4.13711 12.9881 4.06836 13.2006 4.06836C13.4131 4.06836 13.5881 4.13711 13.7256 4.27461C13.8631 4.41211 13.9318 4.58711 13.9318 4.79961C13.9318 5.01211 13.8631 5.18711 13.7256 5.32461L10.0506 8.99961L13.7256 12.6746C13.8631 12.8121 13.9318 12.9871 13.9318 13.1996C13.9318 13.4121 13.8631 13.5871 13.7256 13.7246C13.5881 13.8621 13.4131 13.9309 13.2006 13.9309C12.9881 13.9309 12.8131 13.8621 12.6756 13.7246L9.00059 10.0496Z",
    fill: "var(--color-primary)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.a130ff28.svg";
export { ForwardRef as ReactComponent };